import styled from '@emotion/styled'

import { AccountSelector } from '@modules-deprecated/app'

export const AllAccountSelector = styled(AccountSelector)`
  display: flex;
  align-items: center;
  margin-bottom: 0;

  label {
    justify-content: flex-end;
    width: auto;
    min-width: 103px;
    margin-right: 15px;
    margin-bottom: 0;
  }
`
